<!-- 签署菜单 -->
<template>
    <div class="sign-menu">

        <div class="tip-container">
            <p>文件签署</p>
            <template v-if="appointCount">
                <p class="tip small-font">文件中已标识出{{appointCount}}处位置需要签章</p>
                <el-button @click="locateAppoint"
                           type="text"
                           icon="iconlocate"> 定位签章位置 {{currIndex}}/{{appointCount}}</el-button>
            </template>
        </div>

        <div class="seal-box">
            <p class="tip"><span class="red-text">拖动</span> 印章至想要加盖的位置</p>
            <p class="tip"
               v-if="hasSeal && this.signPage.signSource === 'ZWDT_OPEN'">
                <el-popover trigger="hover"
                            placement="right"
                            width="120">
                    <div class="seal-image transform-center drag-cover">
                        <img :src="qrCode">
                    </div>
                    <span slot="reference"
                          class="red-text">重新设置个人签名</span>
                </el-popover>
            </p>

            <div>
                <!-- 个人签章 -->
                <div class="seal-container"
                     v-if="signType === 'PERSONAL_PIN'">
                    <template v-if="hasSeal">
                        <div class="seal-image transform-center drag-cover"
                             @dragstart="onDragStart($event, 'SEAL_PERSONAL', personalSeal, sealSpec.width, sealSpec.height)"
                             draggable>
                            <img :src="personalSeal"
                                 alt="">
                        </div>
                        <p class="seal-name">个人签名</p>
                    </template>
                    <template v-else>
                        <div class="seal-image transform-center drag-cover">
                            <img :src="qrCode">
                        </div>
                        <p class="seal-name">暂无个人签名，请使用手机扫码设置</p>
                    </template>
                </div>

                <!-- ukey 签提示 -->
                <!-- isEtlType 不需要插 ukey, 不需要 ukey 插入检测 -->
                <template v-else-if="!isEtlType">
                    <div v-if="!ukeyInit"
                        class="seal-container small-font red-text">
                        <template v-if="Utils.isIE()">未检测到协卡/证书助手，请确认是否运行，或重启后再插入UKey</template>
                        <template v-else>请确认是否运行协卡/证书助手并且插入UKey</template>
                    </div>
                    <div v-else-if="!ukeyLinked"
                        class="seal-container small-font red-text">
                        未检测到UKey，请确保已插入
                    </div>
                    <!-- ukey 签提示 -->

                    <!-- 法人Ukey签章 -->
                    <template v-else-if="hasUkey && verify && imageUrl && !isUkeyPerson">
                        <div class="seal-container">
                            <div class="seal-image transform-center drag-cover"
                                v-if="isZWFWSEAL || isPDF"
                                @dragstart="onDragStart($event, 'SEAL_CORPORATE', imageUrl, sealSpec.width, sealSpec.height)"
                                draggable>
                                <img :src="imageUrl"
                                    alt="">
                            </div>

                            <div v-else class="seal-container small-font red-text">请使用有效的国办印章</div>
                            <p class="seal-name"  v-if="isZWFWSEAL || isPDF">{{sealName ? sealName : '法人签章'}}</p>

                        </div>

                        <div class="across-btn" v-if="isPDF">
                            <p class="triggle-btn"
                            @click="signPage.createAcrossPage('ACROSS_PAGE', imageUrl, sealSpec.width / 2, sealSpec.height)">点击加盖骑缝章</p>
                        </div>
                    </template>

                    <!-- 个人Ukey签署 -->
                    <template v-else-if="!personalSeal && isUkeyPerson">
                        <div class="seal-container">
                             <div class="seal-image transform-center drag-cover"
                                @dragstart="onDragStart($event, 'SEAL_PERSONAL_UKEY', `data:image/png;base64,${app.picData}`, sealSpec.width, sealSpec.height)"
                                draggable>
                                <img :src="`data:image/png;base64,${app.picData}`" alt="">
                             </div>
                        </div>
                    </template>

                    <div v-else-if="hasRegisterNo && hasUkey && !verify || !hasUkey"
                        class="seal-container small-font red-text">
                        当前没有有效印章，请检查是否已插入UKEY设备或申请印章！
                    </div>
                    <div v-else-if="!hasRegisterNo" class="seal-container small-font red-text">您的数字证书内没有统一社会信用代码信息，请尽快至就近的数字证书服务网点进行数字证书信息的更新</div>
                    <div v-else
                        class="seal-container small-font red-text">
                        系统正在检测UKEY印章，请稍后...
                    </div>
                </template>

                <!-- 法人Ukey签章 -->
                <template v-else-if="hasUkey && verify && imageUrl && !isUkeyPerson" >
                    <div class="seal-container">
                        <div class="seal-image transform-center drag-cover"
                             v-if="isZWFWSEAL || isPDF"
                             @dragstart="onDragStart($event, 'SEAL_CORPORATE', imageUrl, sealSpec.width, sealSpec.height)"
                             draggable>
                            <img :src="imageUrl"
                                 alt="">
                        </div>

                        <div v-else class="seal-container small-font red-text">请使用有效的国办印章</div>
                        <p class="seal-name"  v-if="isZWFWSEAL || isPDF">{{sealName ? sealName : '法人签章'}}</p>

                    </div>

                    <div class="across-btn" v-if="isPDF">
                        <p class="triggle-btn"
                           @click="signPage.createAcrossPage('ACROSS_PAGE', imageUrl, sealSpec.width / 2, sealSpec.height)">点击加盖骑缝章</p>
                    </div>
                </template>

                <div v-else-if="hasRegisterNo && hasUkey && !verify || !hasUkey"
                     class="seal-container small-font red-text">
                    当前没有有效印章，请检查是否已插入UKEY设备或申请印章！
                </div>
                <div v-else-if="!hasRegisterNo" class="seal-container small-font red-text">您的数字证书内没有统一社会信用代码信息，请尽快至就近的数字证书服务网点进行数字证书信息的更新</div>
                <div v-else
                     class="seal-container small-font red-text">
                    系统正在检测UKEY印章，请稍后...
                </div>

                <!-- 时间戳 -->
                <div
                    v-if="canSignTimestamp"
                    class="choose-timestamp menu-item"
                >
                    <p class="tip"><span class="red-text">拖动</span> 落款日期至想要加盖的位置</p>
                    <el-popover
                        ref="datePattern"
                        placement="right"
                        popper-class="choose-timestamp-popper"
                        trigger="click"
                    >
                        <div>
                            <p class="title">切换日期格式</p>
                            <div
                                v-for="pattern in patternList"
                                :key="pattern"
                                class="drag-cover"
                                draggable="true"
                                @click="choosePattern(pattern)"
                                @dragstart="onDragStartTimestamp($event, getTimeStampImage(pattern))"
                            >
                                <img
                                    class="date"
                                    :src="getTimeStampImage(pattern)"
                                />
                            </div>
                        </div>
                    </el-popover>
                    <div
                        class="drag-cover"
                        draggable="true"
                        @dragstart="onDragStartTimestamp($event, getTimeStampImage(datePattern))"
                    >
                        <img
                            class="date"
                            :src="getTimeStampImage(datePattern)"
                        />
                        <el-tooltip
                            content="切换日期格式"
                            placement="top"
                            v-popover:datePattern
                        >
                            <div class="date-popover-zone"></div>
                        </el-tooltip>
                    </div>
                </div>
            </div>


            <div style="text-align: center;"  v-if="isPDF">
                <el-button @click="addQrCode"
                            type="text"
                            v-if="!visiblePreviewQr">
                            点击添加防伪二维码
                </el-button>
            </div>

            <div v-if="licenseNo" class="licenseNo-content">
                <el-popover
                    placement="right"
                    width="300"
                    trigger="hover"
                >
                    <div class="license-container">
                        {{ licenseNo }}
                    </div>
                    <el-button type="text" class="red-text" slot="reference">查看电照序列号</el-button>
                </el-popover>
            </div>

        </div>
    </div>
</template>
<script>
import qs from 'qs';

export default {
    name: 'SignMenu',
    props: {
        signType: String,
        quser: Object,
        personalSeal: String,
        imageUrl: String,
        rectangles: Array,
        hasUkey: Boolean,
        verify: Boolean,
        sealSpec: Object,
        sealName: String,
        loadingSeal: Boolean,
        hasSeal: Boolean,
        qrCode: String,
        visiblePreviewQr: Boolean,
        isPDF:Boolean,
        isZWFWSEAL:Boolean,
        hasRegisterNo:Boolean,
        isEtlType: Boolean,
        timeStampControlAdd: Boolean,
        licenseNo: {
            type: String,
            default: ''
        },
    },
    data () {
        return {
            currIndex: 0,
            datePattern: 'SECONDARY_THIRD',//当前的日期格式
            patternConfig: ['SECONDARY_THIRD', 'CHINESE_Y_M_D','CHINESE_Y_M_D_MINUTE','CHINESE_Y_M_D_HOUR_MINUTE'],
        };
    },
    inject: ['app', 'signPage'],
    computed: {
        appointCount () {
            return this.rectangles.length || 0;
        },
        ukeyInit() {
            return this.app.ukeyInit;
        },
        ukeyLinked() {
            return this.app.ukeyLinked;
        },
        isUkeyPerson() {
            return this.signType === 'SEAL_UKEY_PERSON';
        },
        canSignTimestamp() {
            return this.signType.includes('PERSONAL') && this.timeStampControlAdd;
        },
        //可选择的格式列表
        patternList () {
            return this.patternConfig.filter(item => item != this.datePattern);
        },
    },
    methods: {
        // 定位签名块
        locateAppoint () {
            if (this.currIndex >= this.appointCount) {
                this.currIndex = 1;
            } else {
                this.currIndex++;
            }
            // let rectangle = this.rectangles[this.currIndex - 1];
            // const documentHeight = document.querySelector('.pdf-scroll-page').offsetHeight;

            // const page = parseInt(rectangle.page);
            // const top = documentHeight * (1 - rectangle.height - rectangle.offsetY);

            // const documentBottom = 15;
            // const scrollDistince = (documentHeight + documentBottom) * (page - 1) + top;

            // this.$nextTick(() => {
            //     document.getElementsByClassName('pdf-document')[0].scrollTop = scrollDistince;
            // });
            this.$emit('scrollTo', this.currIndex);
        },

        /**
         * 为拖拽源监听dragstart,设置关联数据
         */
        onDragStart (event, sealType, src, width, height) {
            width = width || 0;
            height = height || 0;
            // 存储拖拽交互信息
            event.dataTransfer.setData(
                'Text',
                `{"sealType": "${sealType}", "height": "${height}", "width": "${width}", "src": "${src}"}`
            );
        },

        addQrCode() {
            this.$emit('getAnnotationQrCode');
        },

        //选择时间格式
        choosePattern (pattern) {
            this.datePattern = pattern;
            this.$emit('changeDatePattern', pattern);

        },

        onDragStartTimestamp (event, src) {
            // 存储拖拽交互信息
            event.dataTransfer.setData(
                'Text',
                `{"sealType": "TIMESTAMP", "height": "${0}", "width": "${0}", "src": "${src}"}`
            );
        },

        // 时间戳图片
        getTimeStampImage (formatType = 'SECONDARY_THIRD') {
            const param = { formatType, zwdt_access_token: this.zwdt_access_token || this.$route.query.zwdt_access_token };
            return `${this.BASE_APP_PATH}/seal/timestamp?${qs.stringify(param)}`;
        },
    },
    created() {

    }
};
</script>

<style lang="less" scoped>
.sign-menu {
    padding: 10px 20px 40px;

    .licenseNo-content {
        text-align: center;
        .license-container {
            height: 32px;
        }
    }

    .tip-container {
        border-bottom: 1px solid @grey-light;
        margin-bottom: 20px;
        padding: 5px 0 20px;
    }

    .seal-box .tip {
        margin-bottom: 20px;
    }

    .seal-container {
        background: @white;
        padding: 16px 0;
        text-align: center;
        min-height: 100px;
        box-shadow: 0 1px 4px 0 rgba(0, 0, 0, 0.1);
        margin-bottom: 20px;

        .seal-image {
            margin: 0 auto;
            width: 200px;
            max-width: 200px;
            cursor: move;
        }
        img {
            width: 80%;
            max-width: 160px;
        }
        .seal-name {
            margin-top: 10px;
        }
    }
    .across-btn {
        background: @white;
        padding: 16px 0;
        text-align: center;
        box-shadow: 0 1px 4px 0 rgba(0, 0, 0, 0.1);
        margin-top: 10px;
        .triggle-btn {
            cursor: pointer;
            &:hover {
                color: @red;
            }
        }
    }
    .pointer {
        font-size: 14px;
        cursor: pointer;
    }
    .drag-cover {
        cursor: move;
    }

    .choose-timestamp {
        margin-top: 40px;

        .menu-name {
            margin-bottom: 10px;
        }

        .title {
            font-size: 14px;
        }

        .drag-cover {
            position: relative;
            display: block;
            width: 100%;
            margin-bottom: 15px;
            border-radius: 4px;
            background-color: #fff;
            border: 1px solid #e5e7ea;
            &:hover {
                border: 1px solid #2489f2;
            }
            .date {
                display: block;
                margin: 0 auto;
                height: 36px;
                cursor: move;
            }
            .date-popover-zone {
                position: absolute;
                cursor: pointer;
                right: 0;
                bottom: 0;
                content: '';
                border-top: 4px solid transparent;
                border-left: 4px solid transparent;
                border-right: 4px solid rgb(150, 150, 150);
                border-bottom: 4px solid rgb(150, 150, 150);
            }
        }
    }
}
</style>
<style lang="less">
@media (max-width: 1440px) {
    .choose-timestamp-popper {
        width: 130px !important;
    }
}

body.close {
    @media (max-width: 1440px) {
        .choose-timestamp-popper {
            width: 160px !important;
        }
    }
}
.choose-timestamp-popper {
    width: 180px;
}
</style>
